/**
 * Quest ids carry a rough ordering prefix — 0StartWoodcutting, 9GiftForBulge,
 * 20-1LightGoods. Plain string comparison puts 10 before 2, which scrambles that
 * order. Numeric collation compares digit runs as numbers, so the prefixes sort the
 * way they read: 0, 1, 2, … 9, 10, … 20-1, 20-2, 20-3, 20ANewBow.
 */
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

export function compareQuestIds(a: string, b: string): number {
  return collator.compare(a, b)
}
